import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { IoSend } from 'react-icons/io5';
import { IoLogoLinkedin, IoLogoGithub, IoMail } from 'react-icons/io5';
import '../../Styles/Footer.css'
import toast from 'react-hot-toast';
const Footer = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_6cqg7mv', 'template_9sh2d01', form.current, 'o3rGs0Pxei2TLopXF')
            .then((result) => {
                console.log(result.text);
                toast.success("Message Sent!")
                e.target.reset()
            }, (error) => {
                console.log(error.text);
                toast.error("Message Couldn't Sent!")
            });
    };
    return (
        <div style={{ backgroundColor: "black", marginTop: "3rem", paddingTop: "59.5px" }}>

            <div className=" footer__container container">
                <div className="footer__firstrow">
                    <div>
                        <div className='styled__heading'>
                            <h1 className='primary__heading gradient__animation' style={{ fontSize: "25px" }}>━━  Connect</h1>
                        </div>
                        <h1 className="footer__heading accent__heading primary__heading" style={{ marginBottom: "3rem", lineHeight: "58px" }}><span style={{ color: "gray" }}>Let's</span> work <br /> <span style={{ color: "gray" }}>together</span></h1>

                        <form ref={form} onSubmit={sendEmail}>
                            <div className="input__group">
                                {/* <label htmlFor="email">Email</label> */}
                                <input placeholder='Your email addresss' className='input__style' type="email" id='email' name="user_email" />
                            </div>
                            <div className="input__group">
                                {/* <label htmlFor="name">Name</label> */}
                                <input placeholder='Your name' className='input__style' type="text" id='subject' name="user_name" />
                            </div>
                            <div className="input__group">
                                {/* <label htmlFor="body">Body</label> */}
                                <textarea placeholder='Tell us how can we help' className='input__style' type="text" id='body' name="message" />
                            </div>
                            <div style={{ textAlign: "right" }}>
                                {/* <input className='dark__button' type="submit" value="Send" /> */}
                                <button type="submit" className='dark__button'><IoSend style={{ paddingBottom: "1px", fontSize: "22px", fontWeight: "600" }} /></button>
                            </div>
                        </form>
                    </div>
                    {/* <form ref={form} onSubmit={sendEmail}>
                        <div className="input__group">
                            <input placeholder='Your email addresss' className='input__style' type="email" id='email' name="user_email" />
                        </div>
                        <div className="input__group">
                            <input placeholder='Your name' className='input__style' type="text" id='subject' name="user_name" />
                        </div>
                        <div className="input__group">
                            <textarea placeholder='Tell us how can we help' className='input__style' type="text" id='body' name="message" />
                        </div>
                        <div style={{ textAlign: "right" }}>
                            <button type="submit" className='dark__button'><IoSend style={{ paddingBottom: "1px", fontSize: "22px", fontWeight: "600" }} /></button>
                        </div>
                    </form> */}
                </div>
            </div>
            {/* <hr /> */}
            <div style={{ borderTop: "1px solid rgba(128, 128, 128, 0.555)" }}>
                <div className="container footer__copyright">
                    <p>Copyright © 2022, Rokan Uddin. All rights reserved.</p>

                    <div className='footer__logo'>
                        <a style={{ color: "black", fontSize: "25px" }} href="mailto:rokanuddinroman"><IoMail color="#fff" /></a>
                        <a style={{ color: "white", fontSize: "25px", marginLeft: "1rem" }} href="https://github.com/rokanuddinroman"><IoLogoGithub /></a>
                        <a style={{ color: "white", fontSize: "25px", marginLeft: "1rem" }} href="https://www.linkedin.com/in/md-rokan-uddin/"><IoLogoLinkedin /></a>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Footer;